import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@brighterion/br-ui';
import { handleKeyEvent, handleOnClickEvent } from '@brighterion/utils/general';
import { ALERT_BANNER_DURATION_IMPORT_EXPORT } from '@brighterion/utils/constants';
import useAlertBanner from 'Hooks/reduxHelperHooks/useAlertBanner';
import useSidePanel from 'Hooks/reduxHelperHooks/useSidePanel';

import styles from '../ListEntriesImport/components/Importer/Importer.css';

type ImportExportSuccessAlertOptions = {
    bannerTextMessage: string;
    alertId?: string;
};

const useImportExportSuccessAlert = () => {
    const { t } = useTranslation();
    const { addAlert, clearAll } = useAlertBanner();
    const { openImportExportQueue } = useSidePanel();

    const callBack = React.useCallback(
        ({ bannerTextMessage, alertId }: ImportExportSuccessAlertOptions) => {
            const viewQueue = () => {
                clearAll();
                openImportExportQueue();
            };
            const bannerText = <span className={styles.bannerText}>{bannerTextMessage} </span>;
            const viewQueueLink = (
                <Button
                    variant='tertiary'
                    size='small'
                    className={styles.viewQueueButton}
                    data-testid='view-queue-button'
                    onClick={handleOnClickEvent(viewQueue)}
                    onKeyDown={handleKeyEvent(viewQueue)}
                    aria-label='view queue'
                    tabIndex={0}
                >
                    {t('View Queue')}
                </Button>
            );
            const bannerContent = (
                <>
                    {bannerText}
                    {viewQueueLink}
                </>
            );
            addAlert({
                id: alertId ?? 'import export success',
                content: bannerContent,
                status: 'success',
                duration: ALERT_BANNER_DURATION_IMPORT_EXPORT
            });
        },
        [addAlert, clearAll, openImportExportQueue, t]
    );
    return callBack;
};

export default useImportExportSuccessAlert;
